import React from 'react';
import { Button } from "@/components/ui/button";
import { BOOKING_URL } from "@/constants/urls"; // Import the booking URL
import heroImageWebP from "@/assets/hero_image.webp";
import heroImageJPG from "@/assets/hero_image.jpg";

const Hero: React.FC = () => {
  return (
    <section className="pt-32 pb-20 md:pt-40 md:pb-28 bg-gradient-to-r from-sage-50 via-white to-amber-50">
      <div className="container mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row items-center md:justify-between">
          <div className="w-full md:w-1/2 mb-10 md:mb-0">
            <h1 className="bg-gradient-to-r from-sage-600 to-amber-500 bg-clip-text text-transparent mb-6 leading-tight">
              Sunshine Coast Acupuncture Clinic - Fertility, Pregnancy & Health
            </h1>
            <p className="text-lg md:text-xl text-gray-700 mb-8 max-w-lg">
              Based in Currimundi, we offer acupuncture, herbal medicine, and lifestyle guidance to support your unique health journey on the Sunshine Coast.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <Button className="bg-amber-600 hover:bg-amber-700 text-white font-medium py-3 px-4 sm:px-6 rounded-full transition-all shadow-md hover:shadow-lg text-sm sm:text-base" asChild>
                <a href="#services">Explore Services</a>
              </Button>
              <Button className="border-2 border-amber-200 text-amber-200 hover:bg-amber-50 font-medium py-3 px-4 sm:px-6 rounded-full transition-all text-sm sm:text-base" asChild>
                <a href="#about">Learn More</a>
              </Button>
            </div>
          </div>
          <div className="w-full md:w-5/12 relative">
            <div className="rounded-2xl overflow-hidden shadow-2xl border-4 border-amber-200/50">
              <picture>
                <source srcSet={heroImageWebP} type="image/webp" />
                <img 
                  src={heroImageJPG}
                  alt="Fertility and women's acupuncture session in Currimundi on the Sunshine Coast"
                  className="w-full h-auto object-cover aspect-[4/3]"
                  loading="eager"
                  decoding="async"
                  aria-describedby="hero-image-description"
                />
              </picture>
              <div id="hero-image-description" className="sr-only">
                A professional acupuncture treatment session showing a woman receiving care in a peaceful clinic setting, representing the holistic approach to women's health at Women and The Way.
              </div>
            </div>
            <div className="absolute -bottom-6 -left-6 bg-white p-4 rounded-lg shadow-lg border border-amber-200/50 w-3/4 md:w-1/2">
              <p className="text-sage-800 font-serif font-medium">
                "Supporting women across the Sunshine Coast with the wisdom of Traditional Chinese Medicine."
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
